import { render } from "./planDetailsComponent.vue?vue&type=template&id=cfccb3d0"
import script from "./planDetailsComponent.vue?vue&type=script&lang=js"
export * from "./planDetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__